// files
import Navigation from "../../Components/Navigation/Navigation";
const HeaderPage = () => {
  return (
    <Navigation />
  )
}
export default HeaderPage;